
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nl/en/privacy-policy",
      function () {
        return require("private-next-pages/nl/en/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nl/en/privacy-policy"])
      });
    }
  